import { useCallback } from "react";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useOverlays } from "contexts/OverlayContext";

export function useNavigateAfterMappingFinalized({
    nextTaskId,
}: {
    nextTaskId: string | undefined;
}) {
    const toaster = useToaster();
    const { closeOverlay } = useOverlays();
    const navigate = useStateAwareNavigate();

    return useCallback(() => {
        toaster.toast("Accounts mapped");
        closeOverlay();
        navigate(
            nextTaskId ? `/?taskId=${encodeURIComponent(nextTaskId)}` : "/",
        );
    }, [toaster, closeOverlay, navigate, nextTaskId]);
}
